import React from 'react';
import useCokitchenContext from 'contexts/cokitchen.context';
import BrandDetailsCard from 'components/brand-details-card';
import LiveTag from 'components/live-tag';
import Chip from 'components/base/chip';

const PreviewKitchenDetails = () => {
  const { createCokitchenForm } = useCokitchenContext();

  return (
    <div>
      <BrandDetailsCard
        data={{
          label: 'CoKitchen Name',
          value: createCokitchenForm?.name
        }}
        className='my-8'
      />
      <BrandDetailsCard
        data={{
          label: 'CoKitchen Address',
          value: createCokitchenForm?.address
        }}
        className='my-8'
      />
      <BrandDetailsCard
        data={{
          label: 'CoKitchen Tagline',
          value: createCokitchenForm?.description
        }}
        className='my-8'
      />
      <BrandDetailsCard
        data={{
          label: 'CoKitchen Service Number',
          value: null,
          tag: (
            <div className='flex flex-wrap gap-4 font-medium'>
              {createCokitchenForm?.customer_service_phone_number?.map((item, index) => (
                <Chip key={index} text={item} />
              ))}
            </div>
          )
        }}
        className='my-8'
      />
      <BrandDetailsCard
        data={{
          label: 'CoKitchen Service Number (WhatsApp)',
          value: null,
          tag: (
            <div className='flex flex-wrap gap-4 font-medium'>
              {createCokitchenForm?.customer_service_whatsapp?.map((item, index) => (
                <Chip key={index} text={item} />
              ))}
            </div>
          )
        }}
        className='my-8'
      />
      <BrandDetailsCard
        data={{
          label: 'Front desk Number',
          value: null,
          tag: (
            <div className='flex flex-wrap gap-4 font-medium'>
              {createCokitchenForm?.frontdesk_phone_number?.map((item, index) => (
                <Chip key={index} text={item} />
              ))}
            </div>
          )
        }}
        className='my-8'
      />
      <BrandDetailsCard
        data={{
          label: 'Front desk Number (WhatsApp)',
          value: null,
          tag: (
            <div className='flex flex-wrap gap-4 font-medium'>
              {createCokitchenForm?.frontdesk_whatsapp?.map((item, index) => (
                <Chip key={index} text={item} />
              ))}
            </div>
          )
        }}
        className='my-8'
      />
      <BrandDetailsCard
        data={{
          label: 'Cokitchen Type',
          value: createCokitchenForm?.cokitchen_status
        }}
        className='my-8'
      />
      <div className='border py-[20px] px-[24px] border-[#EDEDEE] rounded-xl flex justify-between my-8'>
        <div className='flex items-center justify-start gap-12'>
          <p className='text-[#858585] font-medium'>Cokitchen Status</p>
          <LiveTag live={createCokitchenForm.active} />
        </div>
      </div>

      {createCokitchenForm?.event_image ? (
        <div className='py-1 border border-1 rounded-[10px] border-[#EDEDEE]'>
          <p className='px-[24px] py-[18px] font-medium text-[#858585] text-sm'>Cokitchen Image</p>
          <hr className='text-[#EDEDEE]' />
          <div className='p-6 flex gap-[20px]'>
            <div className='w-full h-[160px]'>
              <img
                className='w-full h-full rounded-[10px] object-cover'
                src={createCokitchenForm?.event_image ?? ''}
              />
            </div>
          </div>
        </div>
      ) : null}
      {createCokitchenForm.cover_images.length > 0 && (
        <div className='py-1 border border-1 rounded-[10px] border-[#EDEDEE] mt-6'>
          <p className='px-[24px] py-[18px] font-medium text-[#858585] text-sm'>
            Cokitchen Display Images
          </p>
          <hr className='text-[#EDEDEE]' />
          <div className='p-6 flex gap-[20px] flex-wrap'>
            {createCokitchenForm.cover_images.map((img, index) => (
              <div key={index} className='w-[160px] h-[160px]'>
                <img
                  className='w-[160px] h-[160px] rounded-[10px] object-cover'
                  src={img}
                  alt={`cover_image-${index}`}
                />
              </div>
            ))}
          </div>
        </div>
      )}
      {createCokitchenForm.cover_videos.length > 0 && (
        <div className='py-1 border border-1 rounded-[10px] border-[#EDEDEE] mt-6'>
          <p className='px-[24px] py-[18px] font-medium text-[#858585] text-sm'>
            Cokitchen Display Videos
          </p>
          <hr className='text-[#EDEDEE]' />
          <div className='p-6 flex gap-[20px] flex-wrap'>
            {createCokitchenForm.cover_videos.map((vid, index) => (
              <div key={index} className='w-[160px] h-[160px]'>
                <video src={vid} controls className='w-full h-full rounded-[10px] object-cover' />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PreviewKitchenDetails;
